import { TThunk } from '../../../';
import { chatsActions } from '../../../config';
import { notifyError } from '../../notifications/actions';

interface IGetChatsParams {
  per_page?: number;
  page?: number;
  order_by_direction?: 'desc' | 'asc';
}

export const getChats =
  (params: IGetChatsParams = {}, loadMore?: boolean): TThunk =>
  async (dispatch, getState, api) => {
    const {
      chats: { loading, listMeta, list },
    } = getState();

    const paramsToSend = params;

    if (loading.list) return;

    if (loadMore) {
      const remainChats = listMeta.total - listMeta.currentPage * Number(listMeta.perPage);

      if (remainChats > 0) {
        paramsToSend.page = listMeta.currentPage + 1;
      } else {
        return;
      }
    }

    dispatch(chatsActions.setLoading({ key: 'list', value: true }));

    const readyToSendParams = {
      page: loadMore ? listMeta.currentPage : 1,
      per_page: Number(listMeta.perPage),
      order_by_direction: listMeta.orderByDirection,
      ...(paramsToSend || {}),
    };

    try {
      const { data, perPage, total } = await api.chats.fetchChats(readyToSendParams);

      dispatch(chatsActions.setChats(readyToSendParams.page === 1 ? data : [...list, ...data]));
      dispatch(
        chatsActions.setChatsMeta({
          perPage,
          total,
          currentPage: readyToSendParams.page,
          orderByDirection: readyToSendParams.order_by_direction,
        }),
      );
    } finally {
      dispatch(chatsActions.setLoading({ key: 'list', value: false }));
    }
  };

export const getOneChat =
  (chatId: string, { notyTitle, notyMessage }: { notyTitle: string, notyMessage: string }): TThunk =>
  async (dispatch, getState, api) => {
    dispatch(chatsActions.setLoading({ key: 'selectedChat', value: true }));

    try {
      const data = await api.chats.fetchOneChat(chatId);
      dispatch(chatsActions.setSelectedChat(data));
    } catch {
      dispatch(
        notifyError({
          title: notyTitle,
          message: notyMessage
        })
      );
    } finally {
      dispatch(chatsActions.setLoading({ key: 'selectedChat', value: false }));
    }
  };
